<ix-application>
  <ix-application-header [name]="applicationName()">
    <user-auth 
        slot="ix-application-header-avatar" />
  </ix-application-header>
  <ix-menu
    [i18nLegal]="'NAVIGATION.ABOUT_AND_LEGAL' | translate"
    [i18nSettings]="'NAVIGATION.SETTINGS' | translate"
    enableToggleTheme="true"
  >
    <ix-menu-item routerLink="/" icon="home">{{"NAVIGATION.HOMEPAGE" | translate}}</ix-menu-item>

    <!-- Settings -->
     <ix-menu-settings>
      <settings />
     </ix-menu-settings>


  <!-- About and legal -->
    <ix-menu-about [label]="'NAVIGATION.ABOUT_AND_LEGAL' | translate">
      <about-info />
    </ix-menu-about>
  </ix-menu>
  <ix-content>
  <router-outlet> </router-outlet>
</ix-content>
</ix-application>
